import type { ComponentType, SVGProps } from 'react'
import {
  ExternalLink,
  FileText,
  Facebook,
  Ghost,
  Globe2,
  Instagram,
  Linkedin,
  MapPin,
  MessageCircle,
  Music2,
  Send,
  Youtube,
} from 'lucide-react'
import type { PublicBusinessLinkKind } from '@seaa/shared'

type SocialIcon = ComponentType<{ size?: number; 'aria-hidden'?: boolean }>

function XIcon({ size = 20, ...props }: SVGProps<SVGSVGElement> & { size?: number }) {
  return <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" focusable="false" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
}

export interface SocialPlatformOption {
  kind: PublicBusinessLinkKind
  label: string
  placeholder: string
  icon: SocialIcon
  social: boolean
}

export const socialPlatformOptions: SocialPlatformOption[] = [
  { kind: 'instagram', label: 'Instagram', placeholder: 'https://instagram.com/yourbusiness', icon: Instagram, social: true },
  { kind: 'x', label: 'X', placeholder: 'https://x.com/yourbusiness', icon: XIcon as SocialIcon, social: true },
  { kind: 'facebook', label: 'Facebook', placeholder: 'https://facebook.com/yourbusiness', icon: Facebook, social: true },
  { kind: 'whatsapp', label: 'WhatsApp', placeholder: 'https://wa.me/966500000000', icon: MessageCircle, social: true },
  { kind: 'telegram', label: 'Telegram', placeholder: 'https://t.me/yourbusiness', icon: Send, social: true },
  { kind: 'tiktok', label: 'TikTok', placeholder: 'https://tiktok.com/@yourbusiness', icon: Music2, social: true },
  { kind: 'youtube', label: 'YouTube', placeholder: 'https://youtube.com/@yourbusiness', icon: Youtube, social: true },
  { kind: 'linkedin', label: 'LinkedIn', placeholder: 'https://linkedin.com/company/yourbusiness', icon: Linkedin, social: true },
  { kind: 'snapchat', label: 'Snapchat', placeholder: 'https://snapchat.com/add/yourbusiness', icon: Ghost, social: true },
  { kind: 'website', label: 'Website', placeholder: 'https://yourbusiness.com', icon: Globe2, social: false },
  { kind: 'directions', label: 'Directions', placeholder: 'https://maps.google.com/…', icon: MapPin, social: false },
  { kind: 'document', label: 'PDF menu / document', placeholder: 'https://yourbusiness.com/menu.pdf', icon: FileText, social: false },
  { kind: 'other', label: 'Another link', placeholder: 'https://', icon: ExternalLink, social: false },
]

const optionByKind = new Map(socialPlatformOptions.map((option) => [option.kind, option]))

export function socialPlatform(kind: PublicBusinessLinkKind) {
  return optionByKind.get(kind) ?? optionByKind.get('other')!
}

export function isSocialPlatform(kind: PublicBusinessLinkKind) {
  return socialPlatform(kind).social
}
